import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatDate, formatEur } from '../../lib/workStatus';
import { Car, Paintbrush, Info } from 'lucide-react';

export const CompanyCostsCard = ({ summary }) => {
  const costs = summary.company_costs || {};
  return (
    <Card className="border-0 shadow-sm border-l-4 border-l-slate-300" data-testid="admin-salary-company-costs">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center justify-between">
          <span>Uzņēmuma izmaksas mēnesī (neietilpst algā)</span>
          <span className="text-[#1F3D2B]" data-testid="admin-salary-company-costs-total">{formatEur(costs.total)}</span>
        </CardTitle>
        <p className="text-xs text-[#2E2E2E]/60 flex items-center gap-1"><Info className="w-3 h-3" /> Transports un krāsa ir uzņēmuma izmaksas — tās redzamas objektu peļņā, darbinieka izmaksājamo summu neietekmē.</p>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div data-testid="admin-salary-mileage">
          <div className="flex items-center justify-between font-medium mb-1"><span className="flex items-center gap-1"><Car className="w-4 h-4" /> Kilometri: {summary.total_km} km</span><span>{formatEur(costs.mileage_cost)}</span></div>
          {summary.mileage.length === 0 ? <p className="text-[#2E2E2E]/60">Nav kilometru ierakstu. <Link to="/portal/admin/mileage" className="text-[#1F3D2B] underline">Pievienot</Link></p> : (
            <div className="divide-y">{summary.mileage.map((m) => <div key={m.id} className="flex justify-between py-1 text-xs"><span>{formatDate(m.date)} · {m.project_name || m.note || '-'}</span><span className="font-medium">{m.kilometers} km</span></div>)}</div>
          )}
        </div>
        <div data-testid="admin-salary-paint">
          <div className="flex items-center justify-between font-medium mb-1"><span className="flex items-center gap-1"><Paintbrush className="w-4 h-4" /> Krāsa: {costs.paint_cans || 0} baloni</span><span>{formatEur(costs.paint_cost)}</span></div>
          {!costs.paint_entries?.length ? <p className="text-[#2E2E2E]/60">Nav krāsas ierakstu. Krāsu pievieno pie objekta izmaksām, norādot darbinieku.</p> : (
            <div className="divide-y">{costs.paint_entries.map((p) => <div key={p.id} className="flex justify-between py-1 text-xs"><span>{formatDate(p.date)} · {p.quantity} gab.{p.note ? ` · ${p.note}` : ''}</span><span className="font-medium">{formatEur(p.amount)}</span></div>)}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
